import { useEffect } from 'react';
import { usePostHog } from 'posthog-js/react';
import { applyServerFlags, onRemoteFlagFailure, remoteFlagsFailed } from '../utils/posthogFlagFallback';

// Signed-in shells only (the endpoint needs auth): if PostHog's own flag load
// failed — before this mounted or any time after — load server-evaluated flags.
export function usePosthogFlagFallback() {
  const posthog = usePostHog();

  useEffect(() => {
    if (!posthog) return undefined;
    if (remoteFlagsFailed()) applyServerFlags(posthog);
    return onRemoteFlagFailure(() => applyServerFlags(posthog));
  }, [posthog]);
}
